import React from "react"
import { useStore } from "../../teafuljs/store"
import { navigate } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"
import { InputLabel, MenuItem, FormControl, Select } from "@material-ui/core"
import ValuesPassages from "../../data/YWAMValues.json"
import GetSegment from "../../scripts/NavigateToSegment"
import scrollToElement from "scroll-to-element"
import { getTranslation } from "../../scripts/getTranslation"
import getVersionVerse from "../../scripts/getVersionVerse"

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  formControl: {
    display: "flex",
    flexWrap: "nowrap",
    margin: theme.spacing(1),
    width: "75%",
    // height: 30,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  group: {
    fontWeight: theme.typography.fontWeightMedium,
    opacity: 1,
    paddingLeft: 5 * theme.spacing.unit,
  },
}))

export default function SimpleSelect(props) {
  const classes = useStyles()
  const translations = useStore.translations()[0];
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0];
  const version = useStore.version()[0];
  const [history, setHistory] = useStore.history();
  const [searchID, setSearchID] = useStore.searchID();
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID();
  const currentKeyPassage = useStore.currentKeyPassage()[0]
  const [currentStateValue, setCurrentStateValue] = useStore.currentValue();
  const [
    currentStateValuePassage,
    setCurrentStateValuePassage,
  ] = useStore.currentValuePassage()
  const [currentValue, setCurrentValue] = React.useState(
    currentStateValue || ""
  )
  const [stateValuePassage, setStateValuePassage] = useStore.valuePassage();
  const [valuePassage, setValuePassage] = React.useState(
    currentKeyPassage !== "" ? currentKeyPassage : ""
  )
  const beliefs = {
    ["BEL-01"]: getTranslation(
      translations,
      language,
      "Values",
      "BEL-01-T"
    ),
    ["BEL-02"]: getTranslation(
      translations,
      language,
      "Values",
      "BEL-02-T"
    ),
    ["BEL-03"]: getTranslation(
      translations,
      language,
      "Values",
      "BEL-03-T"
    ),
    ["BEL-04"]: getTranslation(
      translations,
      language,
      "Values",
      "BEL-04-T"
    ),
    ["BEL-05"]: getTranslation(
      translations,
      language,
      "Values",
      "BEL-05-T"
    ),
    ["BEL-06"]: getTranslation(
      translations,
      language,
      "Values",
      "BEL-06-T"
    ),
  }
  const values = {
    ["VAL-01"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-01-T"
    ),
    ["VAL-02"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-02-T"
    ),
    ["VAL-03"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-03-T"
    ),
    ["VAL-04"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-04-T"
    ),
    ["VAL-05"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-05-T"
    ),
    ["VAL-06"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-06-T"
    ),
    ["VAL-07"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-07-T"
    ),
    ["VAL-08"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-08-T"
    ),
    ["VAL-09"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-09-T"
    ),
    ["VAL-10"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-10-T"
    ),
    ["VAL-11"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-11-T"
    ),
    ["VAL-12"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-12-T"
    ),
    ["VAL-13"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-13-T"
    ),
    ["VAL-14"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-14-T"
    ),
    ["VAL-15"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-15-T"
    ),
    ["VAL-16"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-16-T"
    ),
    ["VAL-17"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-17-T"
    ),
    ["VAL-18"]: getTranslation(
      translations,
      language,
      "Values",
      "VAL-18-T"
    ),
  }

  const isStandardVersification =
    AvailableContent.content[language].versions[version]
      .versification === "standard"

  function handleValueChange(event) {
    setCurrentValue(event.target.value)
    setCurrentStateValue(event.target.value)
    setStateValuePassage("")
  }
  function handleValuePassageChange(event) {
    setValuePassage(event.target.value)
    setStateValuePassage(event.target.value)
    const newVP = event.target.value
    const versionRef = !isStandardVersification
      ? ValuesPassages[newVP].ref
      : ValuesPassages[newVP].sRef || ValuesPassages[newVP].ref
    const book = versionRef.substring(0, 3)
    const isAvailable =
      AvailableContent.content[language][version][book] &&
      AvailableContent.content[language][version][book]
        .segments.length > 1
        ? true
        : false
    if (isAvailable) {
      search(versionRef)
    }
  }

  function getValuesPassages(valueID) {
    let ValuesData = Object.values(ValuesPassages).filter(
      p => p.id.substring(0, 6) === valueID
    )
    ValuesData = ValuesData.sort(function(a, b) {
      if (+a.id.substring(4, 6) < b.id.substring(4, 6)) {
        return -1
      } else if (a.id.substring(4, 6) > b.id.substring(4, 6)) {
        return 1
      } else if (a.id.substring(4, 6) === b.id.substring(4, 6)) {
        return 0
      } else {
        return 0
      }
    })
    return ValuesData
  }

  function search(RefID) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const refInfo = RefID.split("-")
    const segment = GetSegment(
      refInfo[0],
      parseInt(refInfo[1]),
      parseInt(refInfo[2])
    )
    setSearchID(RefID)
    if (props.location.pathname === "/") {
      setCurrentSegmentID(segment)
      navigate("/reader")
    } else if (currentSegmentID === segment) {
      props.closeMenu()
      samePageNavigation(`ref-${RefID}`)
    } else {
      props.closeMenu()
      setCurrentSegmentID(segment)
    }
  }

  function samePageNavigation(id) {
    const element = document.querySelectorAll(`[verseref=${id}]`)[0]
    scrollToElement(element, {
      offset: -65,
      ease: "inOutCube",
      duration: 1500,
    })
    setSearchID("")
  }
  return (
    <form className={classes.root} autoComplete="off">
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="age-simple">
          {getTranslation(
            translations,
            language,
            "UI",
            "menu_value"
          )}
        </InputLabel>
        <Select value={currentValue} onChange={handleValueChange}>
          <MenuItem disabled className={classes.group}>
            {getTranslation(
              translations,
              language,
              "Values",
              "BEL-T"
            ).toUpperCase()}
          </MenuItem>
          {Object.keys(beliefs).map((v, index) => {
            const num = +v.substring(4, 6)
            return (
              <MenuItem key={index} value={v}>
                {num}. {beliefs[v].toUpperCase()}
              </MenuItem>
            )
          })}
          <MenuItem disabled className={classes.group}>
            {getTranslation(
              translations,
              language,
              "Values",
              "VAL-T"
            ).toUpperCase()}
          </MenuItem>
          {Object.keys(values).map((v, index) => {
            const num = +v.substring(4, 6)
            return (
              <MenuItem key={index} value={v}>
                {num}. {values[v].toUpperCase()}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      {currentStateValue && (
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="age-simple">
            {getTranslation(
              translations,
              language,
              "UI",
              "menu_value_passage"
            )}
          </InputLabel>
          <Select value={currentValue} onChange={handleValuePassageChange}>
            {currentStateValue ? (
              getValuesPassages(currentStateValue).map((v, index) => {
                const book = v.ref.substring(0, 3)
                const isAvailable =
                  AvailableContent.content[language][version][
                    book
                  ] &&
                  AvailableContent.content[language][version][
                    book
                  ].segments.length > 1
                    ? false
                    : true
                return (
                  <MenuItem
                    key={index}
                    style={
                      isAvailable
                        ? { color: "grey", fontStyle: "italic" }
                        : null
                    }
                    value={v.id}
                  >
                    {`#${v.id.split("-")[2]}: ${getTranslation(
                      translations,
                      language,
                      "Books",
                      `abbrev_${ValuesPassages[v.id].fullRef.substring(0, 3)}`
                    )}`}{" "}
                    {ValuesPassages[v.id].fullRef.substring(4)}
                  </MenuItem>
                )
              })
            ) : (
              <MenuItem value="">Select Belief/Value First</MenuItem>
            )}
          </Select>
        </FormControl>
      )}
    </form>
  )
}
